import React from "react";
import PropTypes from "prop-types";

const CarHeading = ({
    lead
}) => {
    const { year, brand, model } = lead;
    const carTitle = [
        year.displayText,
        brand.displayText,
        model.displayText
    ].join(" ");
    return <React.Fragment>{carTitle}</React.Fragment>;
};

CarHeading.propTypes = {
    lead: PropTypes.object.isRequired
};

export default CarHeading;
